export const METRICS = {
  EXECUTOR: 'executor',
  EVENT: {
    REGISTER: 'registro',
  },
  CATEGORY: {
    LANDING: 'landing',
  },
  ACTION: {
    CLICK: 'click',
  },
  LABEL: {
    SING_UP: 'registrate',
    LOG_IN: 'inicia sesion',
    FREE_WATCH: 'ver gratis',
  },
};
